function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef, lazy, Suspense, Fragment } from 'react';
import Loader from '../shared/Loader';
var elementComponents = {
  accordion: 'Accordion',
  audio: 'Audio',
  blockquote: 'Blockquote',
  blog_list: 'BlogList',
  button: 'Button',
  code_block: 'CodeBlock',
  contact_form: 'ContactForm',
  checklist: 'Checklist',
  map: 'GoogleMap',
  heading: 'Header',
  video: 'Video',
  icon: 'Icon',
  image: 'Image',
  divider: 'Divider',
  testimonials: 'Testimonials',
  slider: 'Slider',
  page_tabs: 'PageTabs',
  skill_bars: 'SkillBars',
  flip_cards: 'FlipCards',
  table: 'Table',
  text_editor: 'Text',
  vimeo: 'Vimeo',
  youtube: 'Youtube'
};
export default function Content(_ref) {
  var appProps = _ref.appProps,
    content = _ref.content,
    getBuilderContentUrl = _ref.getBuilderContentUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(content || []),
    _useState4 = _slicedToArray(_useState3, 2),
    containers = _useState4[0],
    setContainers = _useState4[1];
  var translations = appProps.translations,
    currentLocale = appProps.currentLocale,
    pageBuilderAdditionalElements = appProps.pageBuilderAdditionalElements,
    currentDevice = appProps.currentDevice;
  var isDesktop = currentDevice === 'desktop';
  var isMobile = currentDevice != 'desktop';
  var ref = useRef();
  useEffect(function () {
    if (!content && (appProps.getBuilderContentUrl || getBuilderContentUrl)) {
      setLoading(true);
      Rails.ajax({
        type: 'GET',
        url: appProps.getBuilderContentUrl || getBuilderContentUrl,
        dataType: 'json',
        success: function success(res) {
          setContainers(res.builderContent[currentLocale]);
          setLoading(false);
          scrollToLocation();
        },
        error: function error(res) {
          setLoading(false);
        }
      });
    }
  }, []);
  function scrollToLocation() {
    if (!location.hash) {
      return true;
    }
    if (location.hash && !ref.current) {
      var scrollableId = location.hash.replace('#', '');
      setTimeout(function () {
        var element = document.getElementById(scrollableId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
          ref.current = true;
        }
      }, 500);
    }
  }
  function renderElement(element) {
    if (pageBuilderAdditionalElements && Object.keys(pageBuilderAdditionalElements).includes(element.contentType)) {
      var Element = pageBuilderAdditionalElements[element.contentType].component;
      var additionalElementAppProps = pageBuilderAdditionalElements[element.contentType].props.appProps;
      return /*#__PURE__*/React.createElement(Element, Object.assign({
        key: element.id,
        item: element
      }, pageBuilderAdditionalElements[element.contentType].props, {
        appProps: _objectSpread(_objectSpread({}, additionalElementAppProps), appProps)
      }));
    } else {
      var _Element = /*#__PURE__*/lazy(function () {
        return import("./elements/".concat(elementComponents[element.contentType]));
      });
      if (element.contentType === 'contact_form') {
        return /*#__PURE__*/React.createElement(Suspense, {
          key: element.id,
          fallback: /*#__PURE__*/React.createElement("div", null)
        }, /*#__PURE__*/React.createElement(_Element, {
          item: element,
          submitFormPath: appProps.builderSubmitFormPath,
          reCaptchaSiteKey: appProps.builderReCaptchaSiteKey,
          translations: translations,
          appProps: appProps
        }));
      } else {
        return /*#__PURE__*/React.createElement(Suspense, {
          key: element.id,
          fallback: /*#__PURE__*/React.createElement("div", null)
        }, /*#__PURE__*/React.createElement(_Element, {
          item: element
        }));
      }
    }
  }
  function renderColumn(column) {
    var columnSettings = column.settings;
    var columnItems = column.items || column.elements; // support old version

    if (fetchImageSource(columnSettings.image)) {
      return /*#__PURE__*/React.createElement("div", {
        key: column.id,
        id: columnSettings.styles.id || '',
        className: "cs-".concat(column.widthRatio, " ").concat(columnSettings.styles.classes || ''),
        style: _objectSpread(_objectSpread({}, columnSettings.styles.marginStyles), {}, {
          position: 'relative',
          height: '100%'
        })
      }, columnSettings.overlay && /*#__PURE__*/React.createElement("div", {
        style: _objectSpread({
          backgroundColor: columnSettings.overlayColor,
          position: 'absolute',
          top: 0,
          right: 0,
          left: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          zIndex: 1
        }, columnSettings.styles.borderStyles)
      }), /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({
          backgroundImage: "url('".concat(fetchImageSource(columnSettings.image), "')"),
          width: '100%'
        }, columnSettings.imageStyles), columnSettings.styles.borderStyles)
      }, /*#__PURE__*/React.createElement("div", {
        style: _objectSpread({
          position: 'relative',
          zIndex: 2
        }, columnSettings.styles.basicStyles)
      }, columnItems.map(function (columnItem) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: columnItem.id
        }, columnItem.type === 'innerColumn' ? renderColumn(columnItem) : renderElement(columnItem));
      }))));
    }
    return /*#__PURE__*/React.createElement("div", {
      key: column.id,
      id: columnSettings.styles.id || '',
      className: "cs-".concat(column.widthRatio, " ").concat(columnSettings.styles.classes || ''),
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, columnSettings.styles.basicStyles), columnSettings.styles.borderStyles), columnSettings.styles.marginStyles), {}, {
        position: 'relative',
        height: '100%'
      })
    }, columnItems.map(function (columnItem) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: columnItem.id
      }, columnItem.type === 'innerColumn' ? renderColumn(columnItem) : renderElement(columnItem));
    }));
  }
  function fetchImageSource(image) {
    if (image && image.source) {
      return typeof image.source === 'string' ? image.source : '';
    }
    return '';
  }
  return /*#__PURE__*/React.createElement("div", {
    style: loading ? {
      minHeight: '100vh'
    } : {},
    className: "builder-wrapper relative ".concat(loading ? 'flex-box items-center content-center' : '')
  }, loading && /*#__PURE__*/React.createElement(Loader, {
    size: 'large',
    position: 'center'
  }), containers && containers.filter(function (container) {
    if (container.settings.visibility && !container.settings.visibility.desktop && isDesktop) return false;else if (container.settings.visibility && !container.settings.visibility.mobile && !isDesktop) return false;else return true;
  }).map(function (container) {
    var containerSettings = container.settings;
    var columns = container.items || container.columns; // support old version

    return /*#__PURE__*/React.createElement("div", {
      key: container.id,
      id: containerSettings.styles.id || '',
      className: "".concat(containerSettings.containerWidth === 'full_width' ? '' : 'main-container', " ").concat(containerSettings.styles.classes || '')
    }, fetchImageSource(containerSettings.image) ? /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-wrap",
      style: _objectSpread({
        position: 'relative'
      }, containerSettings.styles.marginStyles)
    }, containerSettings.overlay && /*#__PURE__*/React.createElement("div", {
      style: _objectSpread({
        backgroundColor: containerSettings.overlayColor,
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 1
      }, containerSettings.styles.borderStyles)
    }), /*#__PURE__*/React.createElement("div", {
      style: _objectSpread(_objectSpread({
        backgroundImage: "url('".concat(fetchImageSource(containerSettings.image), "')"),
        width: '100%'
      }, containerSettings.imageStyles), containerSettings.styles.borderStyles)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-wrap",
      style: _objectSpread({
        position: 'relative',
        zIndex: 2,
        width: '100%'
      }, containerSettings.styles.basicStyles)
    }, columns.map(function (column) {
      return renderColumn(column);
    })))) : /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-wrap",
      style: _objectSpread(_objectSpread(_objectSpread({
        position: 'relative'
      }, containerSettings.styles.basicStyles), containerSettings.styles.borderStyles), containerSettings.styles.marginStyles)
    }, columns.map(function (column) {
      return renderColumn(column);
    })));
  }));
}